// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9d28cc57","703":"f5dcddc9"}[chunkId] + ".chunk.js";
};